import { gql } from '@apollo/client';

export const GET_ALL_FACILITIES = gql`
  query GetAllFacilities {
    GetAllFacilities {
      Id
      Name
      IsEnergyCreditsEnabled
      KeyChain {
        LegacyId
      }
    }
  }
`;

export const UPDATE_FACILITY_ENERGY_CREDITS_ENABLED = gql`
  mutation UpdateFacilityEnergyCreditsEnabled($id: ID!, $payload: String!) {
    UpdateFacilityEnergyCreditsEnabled(Id: $id, Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;
